import React from 'react';

const CreateDesign = () => {
	return (
		<div className="popup-wrapper create-design-option-modal">
			<div className="common-popup create-design-option-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Create design option</h3>
					</div>
					<div className="close-btn">
						<img alt="close" src=" /icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Brand</label>
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<img src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Who wil customise this option</label>
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<img src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateDesign;
